export interface MaterialGroup {
  id: string
  naslov: string
  opis: string
  stevilo: string
  icon: 'note' | 'posnetki' | 'dokumenti' | 'drive'
  link: string
}

export const materialGroups: MaterialGroup[] = [
  {
    id: 'note',
    naslov: 'Note',
    opis: 'Partiture tekočega programa, urejene po skladbah in glasovih.',
    stevilo: '24 datotek',
    icon: 'note',
    link: 'https://drive.google.com/drive/folders/mepz-viva-note',
  },
  {
    id: 'posnetki',
    naslov: 'Posnetki',
    opis: 'Vadbeni posnetki po glasovih in referenčne izvedbe.',
    stevilo: '18 posnetkov',
    icon: 'posnetki',
    link: 'https://drive.google.com/drive/folders/mepz-viva-posnetki',
  },
  {
    id: 'dokumenti',
    naslov: 'Interni dokumenti',
    opis: 'Pravila zbora, zapisniki, obrazci in seznam koncertnih oblek.',
    stevilo: '9 dokumentov',
    icon: 'dokumenti',
    link: 'https://drive.google.com/drive/folders/mepz-viva-dokumenti',
  },
]

export interface RecentFile {
  id: string
  ime: string
  skupina: string
  dodano: string
}

export const recentFiles: RecentFile[] = [
  { id: 'f1', ime: 'Mozart — Requiem (partitura).pdf', skupina: 'Note', dodano: '28. 10. 2026' },
  { id: 'f2', ime: 'Requiem — Lacrimosa (tenor).mp3', skupina: 'Posnetki', dodano: '28. 10. 2026' },
  { id: 'f3', ime: 'Sveta noč — priredba VIVA.pdf', skupina: 'Note', dodano: '14. 10. 2026' },
  { id: 'f4', ime: 'Program božičnega koncerta.docx', skupina: 'Interni dokumenti', dodano: '9. 10. 2026' },
]
